module.exports = "mutation ValidateUsername($username: String!) {\n  validateUsername(username: $username) {\n    valid\n  }\n}\n"